import React from 'react';
import { Row, Col, Well } from 'react-bootstrap';
import Slider from '@mygooder/react-slick';
import PoiCard from './../shared/PoiCard';
import { NextArrow, PrevArrow } from './../../shared/SliderArrows';

import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import find from 'lodash/find';
import isNil from 'lodash/isNil';

import './eventscardsslider.scss';

class EventsCardsSlider extends React.Component {

  constructor(props) {
    super(props);
    this.handleAfterChange = this.handleAfterChange.bind(this);
    this.goToFirstCard = this.goToFirstCard.bind(this);
  }

  handleAfterChange(currentIndex) {

    const sliderCount = this.slider.props.children.length;
    const currentBreakpoint = this.slider.state.breakpoint;
    const currentSlidesToShow = (find(this.slider.props.responsive, ['breakpoint', currentBreakpoint]) || {}).settings.slidesToShow;

    if(sliderCount < currentSlidesToShow) return;

    const minShowIndex = Math.floor(currentSlidesToShow/2);
    let maxShowIndex = (sliderCount - 1) - minShowIndex;
    if(currentSlidesToShow % 2 == 0) maxShowIndex++;

    if(currentIndex < minShowIndex) {
      let self = this;
      setTimeout(function(){ 
        self.slider.slickGoTo(minShowIndex); 
      }, 0);
      return;
    }

    if(currentIndex > maxShowIndex) {
      let self = this;
      setTimeout(function(){ 
        self.slider.slickGoTo(maxShowIndex); 
      }, 0);
      return;
    }
  }

  goToFirstCard() {
    const currentBreakpoint = this.slider.state.breakpoint;
    const currentSlidesToShow = (find(this.slider.props.responsive, ['breakpoint', currentBreakpoint]) || {}).settings.slidesToShow;
    const minShowIndex = Math.floor(currentSlidesToShow/2);
    /* This defer prevents Key missing error when using inner slider into component lifecycle... :-| */
    let self = this;
    setTimeout(function(){ 
      self.slider.slickGoTo(minShowIndex); 
    }, 0);
  }

  componentDidMount() {
    this.goToFirstCard();
  }

  componentWillUpdate(nextProps) {
    if(this.props.eventsCategory != nextProps.eventsCategory) {
      this.goToFirstCard();
    }
  }

  render() {

    const slickSettings = {
      afterChange: this.handleAfterChange,
      swipeToSlide: false,
      infinite: false,
      centerMode: true,
      variableWidth: false,
      prevArrow: <PrevArrow/>,
      nextArrow: <NextArrow/>,
      responsive: [ 
        { breakpoint: 768, settings: { initialSlide: 0, slidesToShow: 1, slidesToScroll: 1, arrows: false } }, 
        { breakpoint: 1024, settings: { initialSlide: 0, slidesToShow: 2, slidesToScroll: 1, arrows: true } }, 
        { breakpoint: 9999, settings: { initialSlide: 0, slidesToShow: 3, slidesToScroll: 1, arrows: true } } 
      ]
    };

    const placeholderCards = [<div key={0}><PoiCard/></div>, <div key={1}><PoiCard/></div>, <div key={2}><PoiCard/></div>, <div key={3}><PoiCard/></div>];

    const eventCards =  this.props.eventsCategory.apiData.map((event, index) => {

      let eventPrice = this.props.translate('events.events_cards_slider.price', {price: event.price, currency: event.currency});
      let freeEvent = false;
      switch (isNil(event.price) || isNaN(event.price) || parseFloat(event.price)) {
        case true:
          eventPrice = null;
          break;
        case 0:
          eventPrice = this.props.translate('events.events_cards_slider.free')
          freeEvent = true;
          break;
      }

      let discountEventPrice = this.props.translate('events.events_cards_slider.discount_price', {discount_price: event.discount_price, currency: event.currency});
      let freeDiscountEvent = false;
      switch (isNil(event.discount_price) || isNaN(event.discount_price) || parseFloat(event.discount_price)) {
        case true:
          discountEventPrice = null;
          break;
        case 0:
          discountEventPrice = this.props.translate('events.events_cards_slider.free_bwr')
          freeDiscountEvent = true;
          break;
      }

      const htmlText = (
        <div>
          <p>{event.description}</p>
          <p>
            <span className={freeEvent ? 'text-success' : null}>
              {freeEvent ? <strong>{eventPrice}</strong> : eventPrice}
            </span>
            <br/>
            <span className={freeDiscountEvent ? 'text-success' : null}>
              {freeDiscountEvent ? <strong>{discountEventPrice}</strong> : discountEventPrice}
            </span>
          </p>
        </div>
      );

      return (<div key={index}>
                <PoiCard title={event.name} 
                         htmlText={htmlText} 
                         buttonText={this.props.translate('events.events_cards_slider.find_out')} 
                         buttonLink={event.link} 
                         backgroundImage={event.picture}/>
              </div>)
    });

    return (
      <Row className="events-eventscardsslider-component">
        <Col xs={12}>
          <div className="events-eventscardsslider-component__title-wrap">
            <h4><strong>{this.props.translate('events.events_cards_slider.title')}</strong></h4>
            <h5>{this.props.translate('events.events_cards_slider.subtitle')}</h5>
          </div>

          <Well bsSize="large">
            <Slider ref={c => this.slider = c } {...slickSettings} className="events-eventscardsslider-component__slider">
              { this.props.eventsCategory.apiData.length > 0 ? eventCards : placeholderCards }
            </Slider>
            <p className="text-right"><small>powered by Musement</small></p>
          </Well>
        </Col>
      </Row>
    );
  }
}

EventsCardsSlider.displayName = 'PagesEventsCardsSlider';
EventsCardsSlider.propTypes = {};
EventsCardsSlider.defaultProps = {};

const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    eventsCategory: state.eventsCategory
  };
};

export default connect(mapStateToProps)(EventsCardsSlider);



// WEBPACK FOOTER //
// ./components/pages/events/EventsCardsSlider.js